import PropTypes from 'prop-types'
import React from 'react'
import { PageHeader, PageContent } from 'SRC/ui'
import { Package } from 'SRC/modules/users/Registration/components/Form/Content/Package'
import { getUserInfo, getProfileLoading } from '../../../selectors'
import { getSelectedPackage, getPackages } from 'SRC/modules/users/packages/selectors'
import { connect } from 'react-redux'
import { Preloader } from 'SRC/ui/Preloader'

export class PackageList extends React.PureComponent {
  render () {
    const {user, packageName, isLoading} = this.props
    return [
      <PageHeader key='header'>Moj Paket</PageHeader>,
      <PageContent key='content'>
        <div className='registracija-content-heading'>
          <h1 className='heading'>{`Izabrani paket ${packageName ? `- ${packageName}` : ``}`}</h1>
          <p>Paket možete promijeniti jednom u mjesecu. Promjena na paketu vam se računa od 1-og sledećeg mjeseca</p>
          <strong>Ukoliko želite da promijenite paket pozovite +382 67 733 941</strong>
        </div>
        <Package currentUserType={user && user.type} page='profile' />
        {isLoading ? <Preloader /> : null}
      </PageContent>
    ]
  }
}

const mapStateToProps = state => {
  let packageName = null
  const selectedPackageId = getSelectedPackage(state)
  const packages = getPackages(state)
  if (Array.isArray(packages) && packages.length && selectedPackageId) {
    const filteredPackage = packages.filter(item => item.id === selectedPackageId)
    if (filteredPackage.length) {
      packageName = filteredPackage[0].name
    }
  }
  return {user: getUserInfo(state), packageName, isLoading: getProfileLoading(state)}
}

PackageList.propTypes = {
  user: PropTypes.shape({
    type: PropTypes.shape().isRequired
  }).isRequired,
  packageName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired
}

PackageList.defaultProps = {
  isLoading: false
}

export default connect(mapStateToProps)(PackageList)
